import { render, staticRenderFns } from "./ReviewProcessDlg.vue?vue&type=template&id=76117c75&scoped=true&"
import script from "./ReviewProcessDlg.vue?vue&type=script&lang=ts&"
export * from "./ReviewProcessDlg.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewProcessDlg.vue?vue&type=style&index=0&id=76117c75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76117c75",
  null
  
)

export default component.exports